import { render, staticRenderFns } from "./sale_support.vue?vue&type=template&id=8278b27a&scoped=true&"
import script from "./sale_support.vue?vue&type=script&lang=js&"
export * from "./sale_support.vue?vue&type=script&lang=js&"
import style0 from "./sale_support.vue?vue&type=style&index=0&id=8278b27a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8278b27a",
  null
  
)

export default component.exports